import React, {useState} from "react";
import {Grid, TextField, Button, MenuItem, IconButton, Autocomplete} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import {AuctionType, LotState, PlanState} from "../../../../utils/enums";
import {PlansFilterParams, SearchFunction} from "../../../../types/plan";
import {useDictionary} from "../../../../utils/useDictionary";
import {LotsFilterParams} from "../../../../types/lot";

const FilterPanel = ({t, onSearch, initialState}: { t: any, onSearch: SearchFunction<LotsFilterParams>, initialState: LotsFilterParams }) => {

    const [year, setYear] = useState<number | null>(initialState.year);
    const [bin, setBin] = useState(initialState.bin);

    const lotState = useDictionary(
        LotState,
        (type) => ({value: type, label: t(`lot_state.${type}`)}),
        {value: '', label: ''}
    );

    const handleSearch = () => {
        const filters: LotsFilterParams = {year, state: (lotState?.selected?.value || null) as LotState, bin};
        onSearch(filters);
    };

    const handleClear = () => {
        setYear(initialState.year);
        setBin(initialState.bin);
        lotState.setSelected({'value': '', 'label': ''})
        onSearch({year: initialState.year, state: initialState.state, bin: initialState.bin});
    }

    const emptyOption = {value: "", label: ""};
    const dictionaryWithEmpty = [emptyOption, ...lotState.dictionary];

    const onClearYear = () => {
        setYear(null);
    }
    return (
        <Grid container marginBottom={2} spacing={2} alignItems="center">

            <Grid item xs={12} sm={3} md={2} lg={2}>
                <TextField
                    fullWidth
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={t("cabinet.plans.filter.financial_year")}
                    type="number"
                    value={year ?? ''}
                    onChange={(e) => setYear(parseInt(e.target.value))}
                    InputProps={{
                        endAdornment: year ? (
                            <IconButton size="small" onClick={onClearYear}>
                                <ClearIcon/>
                            </IconButton>
                        ) : undefined,
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={3} md={2} lg={2}>
                <TextField
                    fullWidth
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={t("cabinet.lots.filter.bin")}
                    value={bin ?? ''}
                    onChange={(e) => setBin(e.target.value)}
                    InputProps={{
                        endAdornment: bin ? (
                            <IconButton size="small" onClick={() => setBin('')}>
                                <ClearIcon/>
                            </IconButton>
                        ) : undefined,
                    }}
                />
            </Grid>

            {/* Выбор типа из выпадающего списка */}
            <Grid item xs={12} sm={3} md={2} lg={2}>
                <Autocomplete
                    disablePortal size="small" sx={{mb: .5}}
                    options={dictionaryWithEmpty}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={lotState.selected}
                    onChange={lotState.onSelectChange}
                    fullWidth
                    renderInput={params =>
                        <TextField {...params} fullWidth color="primary"
                                   name="lotState" label={t("cabinet.lots.filter.status")}
                        />
                    }
                />
            </Grid>

            {/* Кнопка для поиска */}
            <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={handleSearch}
                    size={'small'}
                >
                    {t("cabinet.lots.filter.search")}
                </Button>
            </Grid>

            <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button
                    fullWidth
                    color="secondary"
                    variant="contained"
                    onClick={handleClear}
                    size={'small'}
                >
                    {t("common.clear")}
                </Button>
            </Grid>
        </Grid>
    );
};

export default FilterPanel;